import * as Yup from "yup";
import Keycloak from "keycloak-js";
import {OpzioniItem} from "../gestversore/types";



export type PrevTesta = {
        id? :number;
        codprev? :string | null;
        idcli? :string  | null;
        codditta? :number;
        note? :string | null;
        desprev? :string | null;
        numord? : string | null;
        numtot?: number;
        coddip?: string;
        flgtemp?: string | null;
        dataprev?:   Date | null;
        codprog?: string | null;
        flgval?: string | null;
        idvmprev?: number | null;

  };



export type PrevTestaForm = {
        codprev? :string | null;
        idcli? :string | null;
        codditta? :number;
        note? :string | null;
        desprev? :string | null;
        numord? :string | null;
        coddip? :string;
        flgtemp? :string | null;
        dataprev?:   Date | null;
        codprog?: string | null;
        flgval?: string | null;
        idvmprev?: number | null;

  };

export type PrevTestaDTO = {
        id? :number;
        codprev? :string;
        idcli?: string;
        codcli? :number;
        codditta? :number;
        note?: string;
        desprev?: string;
        numord?: string;
        descli? :string;
        numtot?: number;
        coddip?: string;
        flgtemp?: string;
        codref? : string
        dataprev?: Date | null;
        codprog?: string;
        flgval?: string;
        idvmprev?: number;

  };


export function mapJsonToPrevTestaDTOApiResponse(jsonData: any): PrevTestaDTOApiResponse {
  const mappedData: PrevTestaDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.VPV02_ID,
      codprev: item.VPV02_CODPREV,
      idcli : item.VPV02_IDCLI,
      codcli: item.VPV02_CODCLI,
      codditta: item.VPV02_CODDITTA,
      note: item.VPV02_NOTE,
      desprev : item.VPV02_DESPREV,
      numord : item.VPV02_NUMORD,
      descli: item.VPV02_DESCLI,
      numtot : item.VPV02_NUMTOT,
      coddip : item.VPV02_CODDIP,
      flgtemp : item.VPV02_FLGTEMP,
      codref : item.VPV02_CODREF,
      dataprev: item.VPV02_DATAPREV,
      codprog: item.VPV02_CODPROG,
      flgval: item.VPV02_FLGVAL,
      idvmprev: item.VPV02_IDVMPREV,
    }))
  };

  return mappedData;
}

export function mapJsonToPrevTesta(jsonData: any): PrevTesta {
    // console.log("JSON:",jsonData);
  return {
      id: jsonData.PV02_ID,
      codprev: jsonData.PV02_CODPREV,
      idcli: jsonData.PV02_IDCLI,
      codditta: jsonData.PV02_CODDITTA,
      note: jsonData.PV02_NOTE,
      desprev: jsonData.PV02_DESPREV,
      numord: jsonData.PV02_NUMORD,
      numtot: jsonData.PV02_NUMTOT,
      coddip: jsonData.PV02_CODDIP,
      flgtemp: jsonData.PV02_FLGTEMP,
      dataprev: jsonData.PV02_DATAPREV,
      codprog: jsonData.PV02_CODPROG,
      flgval: jsonData.PV02_FLGVAL,
      idvmprev: jsonData.PV02_IDVMPREV,
    };
}




export function mapPrevTestaFormToJson(prevTestaForm: PrevTestaForm) {
  return {
    PV02_CODPREV: prevTestaForm.codprev,
    PV02_IDCLI: prevTestaForm.idcli,
    PV02_CODDITTA: prevTestaForm.codditta,
    PV02_NOTE: prevTestaForm.note,
    PV02_DESPREV: prevTestaForm.desprev,
    PV02_NUMORD: prevTestaForm.numord,
    PV02_CODDIP: prevTestaForm.coddip,
    PV02_FLGTEMP: prevTestaForm.flgtemp,
    PV02_DATAPREV: prevTestaForm.dataprev,
    PV02_CODPROG: prevTestaForm.codprog,
    PV02_FLGVAL: prevTestaForm.flgval,
    PV02_IDVMPREV: prevTestaForm.idvmprev,
   };
}


export function mapPrevTestaToJson(prevTesta: PrevTesta) {
  return {
    PV02_ID: prevTesta.codprev,
    PV02_CODPREV: prevTesta.codprev,
    PV02_IDCLI: prevTesta.idcli,
    PV02_CODDITTA: prevTesta.codditta,
    PV02_NOTE: prevTesta.note,
    PV02_DESPREV: prevTesta.desprev,
    PV02_NUMORD: prevTesta.numord,
    PV02_CODDIP: prevTesta.coddip,
    PV02_FLGTEMP: prevTesta.flgtemp,
    PV02_DATAPREV: prevTesta.dataprev,
    PV02_CODPROG: prevTesta.codprog,
    PV02_FLGVAL: prevTesta.flgval,
    PV02_IDVMPREV: prevTesta.idvmprev,
   };
}



export type  PrevTestaDTOApiResponse = {
  results: Array<PrevTestaDTO>;
  count: number;
};


export  type ClientiDTO = {
    idcli: string;
    label: string;
    };

export type  ClientiDTOApiResponse = {
  results: Array<ClientiDTO>;
  count: number;
};
export function mapJsonToClientiDTOApiResponse(jsonData: any): ClientiDTOApiResponse {
  const mappedData: ClientiDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      idcli: item.VPV10_IDCLI,
      label: item.VPV10_DESCLI,
    }))
  };

  return mappedData;
};

export  type CustElem = {
    codareacust: string;
    desareacust: string;
    codmodcust: string;
    desmodcust: string;
    codnodoareacust: string;
    codnodomodcust: string;
    seqareacust: number;
    seqmodcust: number;
    };


export type  CustElemApiResponse = {
  results: Array<CustElem>;
  count: number;
};

export function mapJsonToCustElemApiResponse(jsonData: any): CustElemApiResponse {
  const mappedData: CustElemApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      codareacust: item.PV13_CODAREACUST,
      desareacust: item.PV13_DESAREACUST,
      codmodcust: item.PV13_CODMODCUST,
      desmodcust: item.PV13_DESMODCUST,
      codnodoareacust: item.PV13_CODNODOAREACUST,
      codnodomodcust: item.PV13_CODNODOMODCUST,
      seqareacust: item.PV13_SEQAREACUST,
      seqmodcust: item.PV13_SEQMODCUST,

    }))
  };

  return mappedData;
};







export type ServElemDTO = {
                id:       string;
                flgse:    string;
                idprevtesta: number;
                idservelem: number;
                desarea:    string;
                desmodulo:  string;
                deslivello: string;
                desservelem: string;
                destipose:  string;
                numanalisi: number;
                numconf:    number;
                numform:    number;
                numtot:     number;
                note:       string;
                ord:       number;
                numprep:     number;
                idprevservelem:   number;
  };




export type  ServElemDTOApiResponse = {
  results: Array<ServElemDTO>;
  count: number;
};

export function mapJsonToServElemDTOApiResponse(jsonData: any): ServElemDTOApiResponse {
  const mappedData: ServElemDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
            id:           item.VPV01_ID,
            flgse:        item.VPV01_FLGSE,
            idprevtesta:  item.VPV01_IDPREVTESTA,
            idservelem:   item.VPV01_IDSERVELEM,
            desarea:      item.VPV01_DESAREA,
            desmodulo:    item.VPV01_DESMODULO,
            deslivello:   item.VPV01_DESLIVELLO,
            desservelem:  item.VPV01_DESSERVELEM,
            destipose:    item.VPV01_DESTIPOSE,
            numanalisi:   item.VPV01_NUMANALISI,
            numconf:      item.VPV01_NUMCONF,
            numform:      item.VPV01_NUMFORM,
            numtot:       item.VPV01_NUMTOT,
            note:         item.VPV01_NOTE,
            ord:          item.VPV01_ORD,
            numprep:      item.VPV01_NUMPREP,
            idprevservelem:     item.VPV01_IDPREVSE
    })),

  };

  return mappedData;
};


export type PrevServElemDTO = {
                id:       string;
                idprevtesta: number;
                idservelem: number;
                codarea:     number;
                desarea:    string;
                codmodulo:  number;
                desmodulo:  string;
                desservelem: string;
                numanalisi: number;
                numconf:    number;
                numform:    number;
                numtot:     number;
                note:       string;
                ord:        number;
                numprep:    number;
  };

export type SumPrevServElemDTO = {
                sum_numanalisi: number;
                sum_numconf:    number;
                sum_numform:    number;
                sum_numtot:     number;
                sum_numprep:     number;
  };


export type  PrevServElemDTOApiResponse = {
  results: Array<PrevServElemDTO>;
  count: number;
};

export type  PrevServElemDTOSumApiResponse = {
  results: Array<PrevServElemDTO>;
  results_sum: Array<SumPrevServElemDTO>;
  count: number;
};


export function mapJsonToPrevServElemDTOApiResponse(jsonData: any): PrevServElemDTOApiResponse {
  const mappedData: PrevServElemDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
            id:           item.VPV04_ID,
            idprevtesta:  item.VPV04_IDPREVTESTA,
            idservelem:   item.VPV04_IDSERVELEM,
            codarea:      item.VPV04_CODAREA,
            desarea:      item.VPV04_DESAREA,
            codmodulo:    item.VPV04_CODMODULO,
            desmodulo:    item.VPV04_DESMODULO,
            desservelem:  item.VPV04_DESSERVELEM,
            numanalisi:   item.VPV04_NUMANALISI,
            numconf:      item.VPV04_NUMCONF,
            numform:      item.VPV04_NUMFORM,
            numtot:       item.VPV04_NUMTOT,
            note:         item.VPV04_NOTE,
            ord:          item.VPV04_ORD,
            numprep:      item.VPV04_NUMPREP,

    }))
  };

  return mappedData;
};


export function mapJsonToPrevServElemDTOSumApiResponse(jsonData: any): PrevServElemDTOSumApiResponse {
  const mappedData: PrevServElemDTOSumApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
            id:           item.VPV04_ID,
            idprevtesta:  item.VPV04_IDPREVTESTA,
            idservelem:   item.VPV04_IDSERVELEM,
            codarea:      item.VPV04_CODAREA,
            desarea:      item.VPV04_DESAREA,
            codmodulo:    item.VPV04_CODMODULO,
            desmodulo:    item.VPV04_DESMODULO,
            desservelem:  item.VPV04_DESSERVELEM,
            numanalisi:   item.VPV04_NUMANALISI,
            numconf:      item.VPV04_NUMCONF,
            numform:      item.VPV04_NUMFORM,
            numtot:       item.VPV04_NUMTOT,
            note:         item.VPV04_NOTE,
            ord:          item.VPV04_ORD,
            numprep:      item.VPV04_NUMPREP,

    })),
    results_sum: jsonData.results_sum.map((item: any) => ({
            sum_numanalisi:   item.sum_numanalisi,
            sum_numconf:      item.sum_numconf,
            sum_numform:      item.sum_numform,
            sum_numtot:       item.sum_numtot,
            sum_numprep:       item.sum_numprep,

    }))
  };

  return mappedData;
};



export type PrevCustElem = {
                id:       string;
                idprevtesta: number;
                desareacust:  string;
                codareacust:  string;
                desmodcust:  string;
                codmodcust:  string;
                numanalisi: number;
                numconf:    number;
                numform:    number;
                numtot:     number;
                numprep:     number;
                note?:     string |null;
                codnodoareacust?:  string|null;
                codnodomodcust?:  string|null;
                seqareacust?:  number|null;
                seqmodcust?:  number|null;
                flgprevcons: 'P' | 'C' | 'F' ;

  };

export type SumCustElem = {
                sum_numanalisi: number;
                sum_numconf:    number;
                sum_numform:    number;
                sum_numtot:     number;
                sum_numprep:     number;
  };


export type  PrevCustElemSumApiResponse = {
  results: Array<PrevCustElem>;
  results_sum: Array<SumCustElem>;
  count: number;
};

export type  PrevCustElemApiResponse = {
  results: Array<PrevCustElem>;
  count: number;
};


export function mapJsonToPrevCustElemApiResponse(jsonData: any): PrevCustElemApiResponse {
  const mappedData: PrevCustElemApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
                    id:           item.PV07_ID,
                    idprevtesta:  item.PV07_IDPREVTESTA_PV02,
                    desareacust:  item.PV07_DESAREACUST,
                    codareacust:  item.PV07_CODAREACUST,
                    desmodcust:  item.PV07_DESMODCUST,
                    codmodcust:  item.PV07_CODMODCUST,
                    numanalisi:   item.PV07_NUMANALISI,
                    numconf:      item.PV07_NUMCONF,
                    numform:      item.PV07_NUMFORM,
                    numtot:       item.PV07_NUMTOT,
                    numprep:       item.PV07_NUMPREP,
                    note:           item.PV07_NOTE,
                    codnodoareacust:  item.PV07_CODNODOAREACUST,
                    codnodomodcust:  item.PV07_CODNODOMODCUST,
                    seqareacust:  item.PV07_SEQAREACUST,
                    seqmodcust:  item.PV07_SEQMODCUST,
                    flgprevcons:  item.PV07_FLGPREVCONS,
             }))

  };

  return mappedData;
};


const parseDecimal = (v: any): number => {
  if (v === null || v === undefined || v === '') return 0;
  if (typeof v === 'number') return v;
  return Number(String(v).replace(',', '.')) || 0;
};



export function mapJsonToPrevCustElemSumApiResponse(jsonData: any): PrevCustElemSumApiResponse {
  const mappedData: PrevCustElemSumApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
                    id:           item.PV07_ID,
                    idprevtesta:  item.PV07_IDPREVTESTA_PV02,
                    desareacust:  item.PV07_DESAREACUST,
                    codareacust:  item.PV07_CODAREACUST,
                    desmodcust:  item.PV07_DESMODCUST,
                    codmodcust:  item.PV07_CODMODCUST,
                    numanalisi:      parseDecimal(item.PV07_NUMANALISI),
                    numconf:         parseDecimal(item.PV07_NUMCONF),
                    numform:         parseDecimal(item.PV07_NUMFORM),
                    numtot:          parseDecimal(item.PV07_NUMTOT),
                    numprep:         parseDecimal(item.PV07_NUMPREP),
                    note:           item.PV07_NOTE,
                    codnodoareacust:  item.PV07_CODNODOAREACUST,
                    codnodomodcust:  item.PV07_CODNODOMODCUST,
                    seqareacust:  item.PV07_SEQAREACUST,
                    seqmodcust:  item.PV07_SEQMODCUST,
                    flgprevcons:  item.PV07_FLGPREVCONS,
             })),
            results_sum: jsonData.results_sum.map((item: any) => ({
                    sum_numanalisi:   item.sum_numanalisi,
                    sum_numconf:      item.sum_numconf,
                    sum_numform:      item.sum_numform,
                    sum_numtot:       item.sum_numtot,
                    sum_numprep:       item.sum_numprep,
            }))
  };

  return mappedData;
};


function replaceDecimalSeparator(value: any): any {
    return value.toString().replace(',', '.');
}

export function mapPrevCustElemToJson(prevCustElem: PrevCustElem) {
  return {
    PV07_ID:                     prevCustElem.id,
    PV07_IDPREVTESTA_PV02:       prevCustElem.idprevtesta,
    PV07_CODAREACUST:            prevCustElem.codareacust,
    PV07_DESAREACUST:            prevCustElem.desareacust,
    PV07_CODMODCUST:             prevCustElem.codmodcust,
    PV07_DESMODCUST:             prevCustElem.desmodcust,
    PV07_NUMANALISI:             replaceDecimalSeparator(prevCustElem.numanalisi ? prevCustElem.numanalisi : 0),
    PV07_NUMCONF:                replaceDecimalSeparator(prevCustElem.numconf ? prevCustElem.numconf : 0),
    PV07_NUMFORM:                replaceDecimalSeparator(prevCustElem.numform ? prevCustElem.numform : 0),
    PV07_NUMTOT:                 replaceDecimalSeparator(prevCustElem.numtot ? prevCustElem.numtot : 0),
    PV07_NUMPREP:                replaceDecimalSeparator(prevCustElem.numprep ? prevCustElem.numprep : 0),
    PV07_NOTE:                   prevCustElem.note,
    PV07_CODNODOAREACUST:        prevCustElem.codnodoareacust,
    PV07_CODNODOMODCUST:         prevCustElem.codnodomodcust,
    PV07_SEQAREACUST:            prevCustElem.seqareacust,
    PV07_SEQMODCUST:             prevCustElem.seqmodcust,
    PV07_FLGPREVCONS:            prevCustElem.flgprevcons,
  };
}





export  type PrevServElem = {
    id?: number;
    idprevtesta: number;
    idservelem: number;
    numprep: number;
    note?: string | null;
    numanalisi: number;
    numconf: number;
    numform: number;
    numtot: number;
    };

export type  PrevServElemApiResponse = {
  results: Array<PrevServElem>;
  count: number;
};




export function mapPrevServElemToJson(prevSE: PrevServElem) {
  return {
      PV04_ID: prevSE.id,
      PV04_IDPREVTESTA_PV02: prevSE.idprevtesta,
      PV04_IDSERVELEM_PV01: prevSE.idservelem,
      PV04_NUMPREP:    replaceDecimalSeparator(prevSE.numprep ? prevSE.numprep : 0),
      PV04_NOTE:        prevSE.note,
      PV04_NUMANALISI:    replaceDecimalSeparator(prevSE.numanalisi ? prevSE.numanalisi : 0),
      PV04_NUMCONF:    replaceDecimalSeparator(prevSE.numconf ? prevSE.numconf : 0),
      PV04_NUMFORM:    replaceDecimalSeparator(prevSE.numform ? prevSE.numform : 0),
      PV04_NUMTOT:    replaceDecimalSeparator(prevSE.numtot ? prevSE.numtot : 0),

  }
}

export function mapJsonToPrevServElemApiResponse(jsonData: any): PrevServElemApiResponse {
  const mappedData: PrevServElemApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
                    id:           item.PV04_ID,
                    idprevtesta:  item.PV04_IDPREVTESTA_PV02,
                    idservelem:  item.PV04_IDSERVELEM_PV01,
                    numanalisi:   item.PV04_NUMANALISI,
                    numconf:      item.PV04_NUMCONF,
                    numform:      item.PV04_NUMFORM,
                    numtot:       item.PV04_NUMTOT,
                    numprep:       item.PV04_NUMPREP,
                    note:           item.PV04_NOTE,
               //     flgprevcons:  item.PV04_FLGPREVCONS,
             }))

  };

  return mappedData;
};










export type RepoPrevTesta = {
        id? :number;
        codprev? :string;
        idcli? :string;
        codditta? :number;
        desprev?: string;

  };

export type  RepoPrevTestaApiResponse = {
  results: Array<RepoPrevTesta>;
  count: number;
};

export function mapJsonToRepoDettTestaApiResponse(jsonData: any): RepoPrevTestaApiResponse {
  const mappedData: RepoPrevTestaApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
                    id:           item.VPV05_ID,
                    codprev:  item.VPV05_CODPREV,
                    codcli:  item.VPV05_CODCLI,
                    codditta:   item.VPV05_CODITTA,
                    descli:   item.VPV05_DESCLI,
                    desprev: item.VPV05_DESPREV,
                    numord: item.VPV05_NUMORD,

    }))
  };

  return mappedData;
};






export type RepoPrevDett = {
                id?: string;
                idprevtesta?: number;
                codarea?: string;
                desarea?: string;
                codmodulo?: string;
                desmodulo?: string;
                numanalisi?: number;
                numconf?: number;
                numform?: number;
                numtot?: number;
                numprep?: number;
                note?: string;
  };

export type  RepoPrevDettApiResponse = {
  results: Array<RepoPrevDett>;
  count: number;
};

export function mapJsonToRepoPrevDettApiResponse(jsonData: any): RepoPrevDettApiResponse {
  const mappedData: RepoPrevDettApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
                    id:           item.VPV06_ID,
                    idprevtesta:  item.VPV06_IDPREVTESTA_PV02,
                    codarea:      item.VPV06_CODAREA,
                    desarea:      item.VPV06_DESAREA,
                    codmodulo:    item.VPV06_CODMODULO,
                    desmodulo:    item.VPV06_DESMODULO,
                    numanalisi:   item.VPV06_NUMANALISI, // Parse to number
                    numconf:      item.VPV06_NUMCONF, // Parse to number
                    numform:      item.VPV06_NUMFORM, // Parse to number
                    numtot:       item.VPV06_NUMTOT, // Parse to number
                    numprep:      item.VPV06_NUMPREP, // Parse to number
                    note:         item.VPV06_NOTE
    }))
  };

  return mappedData;
};

export type Dipendenti = {
        id? :number;
        codditta? :string;
        coddip? :string;
        username? :string;
        tipodip?: string;
        nomedip?: string;
        flgdel?: string;

  };

export type  DipendentiApiResponse = {
  results: Array<Dipendenti>;
  count: number;
};

export function mapJsonToDipendentiApiResponse(jsonData: any): DipendentiApiResponse {
  const mappedData: DipendentiApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
            id:           item.VPV30_ID,
            codditta:  item.VPV30_CODDITTA,
            coddip:    item.VPV30_CODDIP,
            username:   item.VPV30_USERNAME,
            tipodip:   item.VPV30_TIPODIP,
            nomedip:   item.VPV30_NOMEDIP,
            flgdel:   item.VPV30_FLGDEL,
    }))
  };

  return mappedData;
};


export  type DipendentiList = {
    coddip: string;
    label: string;
    };

export type  DipendentiListApiResponse = {
  results: Array<DipendentiList>;
  count: number;
};

export function mapJsonToDipendentiListApiResponse(jsonData: any): DipendentiListApiResponse {
  const mappedData: DipendentiListApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      coddip: item.VPV30_CODDIP,
      label: item.VPV30_NOMEDIP,
    }))
  };

  return mappedData;
};


export  type VMPrevList = {
    idvmprev: number;
    desvm: string;
    label: string;
    };

export type  VMPrevListApiResponse = {
  results: Array<VMPrevList>;
  count: number;
};

export function mapJsonToVMPrevListApiResponse(jsonData: any): VMPrevListApiResponse {
  const mappedData: VMPrevListApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      idvmprev: item.PV60_IDVMPREV,
      desvm: item.PV60_DESVM,
      label: item.PV60_DESVM,
    }))
  };

  return mappedData;
};





export type Gruppi = {
        id? :number;
        username? :string;
        gruppo? :string;

  };

export type  GruppiApiResponse = {
  results: Array<Gruppi>;
  count: number;
};

export function mapJsonToGruppiApiResponse(jsonData: any): GruppiApiResponse {
  const mappedData: GruppiApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
            id:           item.VPV35_ID,
            username:   item.VPV35_USERNAME,
            gruppo:   item.VPV35_GRUPPO

    }))
  };

  return mappedData;
};



export const FlgPrevCons: OpzioniItem[] = [
  { id: "P",  label: "Preventivo" },
  { id: "C",  label: "Consuntivo" },

];


